import { IconProps } from "@models/types";
import { SVGAttributes } from "react";

export function XIcon({
  className,
  width,
  height,
  ...others
}: SVGAttributes<SVGAElement>) {
  return (
    <>
      <svg
        className={className}
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 20 20"
        {...others}
      >
        <g id="Group_1404" data-name="Group 1404">
          <path d="M17.76,18.69a.93.93,0,0,1-.66-.27L1.58,2.9A.93.93,0,0,1,2.9,1.58L18.42,17.1a.94.94,0,0,1,0,1.32A.93.93,0,0,1,17.76,18.69Z" />
          <path id="Path_152" data-name="Path 152" d="M17.76,2.24,2.24,17.76" />
          <path d="M2.24,18.69a.93.93,0,0,1-.66-.27.94.94,0,0,1,0-1.32L17.1,1.58A.93.93,0,0,1,18.42,2.9L2.9,18.42A.93.93,0,0,1,2.24,18.69Z" />
        </g>
      </svg>
    </>
  );
}
